module.exports = __webpack_public_path__ + "assets/humidity.png?b39278330fa87dd2ed2c2faeb5a83f22";